import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import { Checkbox, Row, Col } from "antd";
import UIManifest from "src/engine/ui/UIManifest";
import { IPanelContext } from "src/engine/context/PanelContext";
import IUIItem from "src/engine/interface/IUIItem";
import "./PCCheckbox.scss";
const CheckboxGroup = Checkbox.Group;

interface IPCCheckbox extends IBaseUI {
    onChange: (active: string[]) => any;
    disabled: boolean;
    defaultValue?: string[] | number[];
    childItems?: any;
    value?: string[];
    col?: number;
    childItemCtrl?: any;
    hasDr?: "true" | "false";
    renderFormItem?: any;
    style?: any;
    transvalue?: boolean;
    transvalueKey?: string;
    itemStyle?: any;
    theme?: string;
    size?: "large" | "default" | "small";
}

interface ICheckboxItem {
    name?: string;
    label?: string;
    value: number;
}

interface ICheckboxState {
    selectValue: string[] | number[];
    showChild: any[];
}

@UIManifest.declare("PCCheckbox", "PCCheckbox组件", UIManifest.Type.PC)
class PCCheckbox extends BaseUI<IPCCheckbox, ICheckboxState> {
    static transformInitValue(value: string, props: IPCCheckbox) {
        const { transvalueKey = "" } = props;
        if (value) return value.split(transvalueKey);
        return [];
    }

    constructor(props: IPCCheckbox) {
        super(props);
        const { defaultValue, childItemCtrl = [] } = props;
        let { value = [] } = props;
        let showChild: any = [];
        if (typeof value === "string") {
            value = JSON.parse(value);
        }
        if (childItemCtrl.length && value && value.length) {
            showChild = childItemCtrl.filter((item: IUIItem) => value.indexOf(item.info.ename) > -1);
        }
        this.state = {
            selectValue: value || defaultValue || [],
            showChild,
        };
    }

    onChange = (e: any) => {
        const { onChange, childItemCtrl = [], transvalue = false, transvalueKey = "" } = this.props;
        const map: any = {
            selectValue: e,
        };
        if (childItemCtrl.length) {
            map.showChild = childItemCtrl.filter((item: IUIItem) => e.indexOf(item.info.ename) > -1);
        }
        this.setState(map);
        if (onChange) {
            if (transvalue) {
                if (Array.isArray(e)) e = e.join(transvalueKey);
            }
            onChange(e);
        }
    };
    transDataSource(data: any) {
        if (typeof data === "string") {
            return { label: data, value: data };
        }
        return data;
    }
    renderAct() {
        const { dataSource = [], disabled, childItems = [], col = 24, childItemCtrl = [], hasDr = "true", renderFormItem, style, itemStyle = {}, theme = "", size = "default" } = this.props;
        return (
            <>
                <CheckboxGroup
                    className={`mode-checkbox ${theme} pc-checkbox-${size}`}
                    onChange={this.onChange}
                    // size="large"
                    disabled={disabled}
                    value={this.state.selectValue}
                    style={style}
                >
                    <Row>
                        {dataSource.length
                            ? dataSource.map((item: ICheckboxItem, key: number) => {
                                item = this.transDataSource(item);
                                return (
                                    <Col span={col} key={key}>
                                        <Checkbox value={item.value} style={itemStyle}>
                                            {item.name || item.label}
                                            {childItems.length > 0 && this.renderChildren([childItems[key]])}
                                        </Checkbox>
                                    </Col>
                                );
                            })
                            : childItemCtrl.map((item: IUIItem) => {
                                return (
                                    <Col span={col} key={item.info.ename} style={itemStyle}>
                                        <Checkbox value={item.info.ename}>{item.info.cname}</Checkbox>
                                    </Col>
                                );
                            })}
                    </Row>
                </CheckboxGroup>
                {childItemCtrl.length > 0
                    ? this.panel((context: IPanelContext) => {
                        return this.state.showChild.length > 0 ? (
                            <div className={`${hasDr === "true" ? "react-props-switch true" : ""}`} style={{ padding: "20px" }}>
                                {this.state.showChild.map((uiItem: IUIItem, index: number) => {
                                    return renderFormItem(uiItem, context);
                                })}
                            </div>
                        ) : null;
                    })
                    : null}
            </>
        );
    }
}

export default PCCheckbox;
